import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { prefetchForPath } from '../queries/prefetch'

export function usePrefetchIntent() {
	const queryClient = useQueryClient()
	return useCallback(
		(path: string) => ({
			onPointerEnter: () => prefetchForPath(queryClient, path),
			onFocus: () => prefetchForPath(queryClient, path),
		}),
		[queryClient],
	)
}
